/*
  House of Zena — Predictive Search Subsystem
  Enterprise Hardened & Race-Condition Protected
*/

class PredictiveSearch extends HTMLElement {
  constructor () {
    super()

    this.form = this.querySelector('form.search-form')
    this.input = this.form?.querySelector('input[type="search"]')
    this.results = this.form?.querySelector('#predictive-search')
    this.status = this.form?.querySelector('#predictive-search-status')

    this.emptyContainer = this.querySelector('.search-empty')
    this.cartUpsells = this.querySelector('#card-upsells-collapse-wrapper')
    this.abortController = null

    if (this.input) {
      this.input.addEventListener('input', window.theme.debounce(() => {
        this.getSearchResults()
      }, 250).bind(this))
    }

    document.querySelector('#offcanvas-search')?.addEventListener('shown.bs.offcanvas', () => {
      this.input?.focus()
    })
    this.accessibilityEventIsInit = false
  }

  async getSearchResults () {
    if (!this.input || !this.results) return

    const searchTerm = this.input.value.trim()

    if (this.abortController) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()

    if (searchTerm.length > 0) {
      const resourceType = encodeURIComponent(this.dataset.resourcesType || 'product')
      const encodedQuery = encodeURIComponent(searchTerm)
      const url = `${window.Shopify.routes.predictive_search_url}?q=${encodedQuery}&resources[type]=${resourceType}&resources[limit]=10&section_id=predictive-search`

      try {
        const response = await fetch(url, { signal: this.abortController.signal })

        if (response.ok) {
          const data = await response.text()
          const sectionEl = new DOMParser().parseFromString(data, 'text/html').querySelector('#shopify-section-predictive-search')

          if (sectionEl) {
            this.results.innerHTML = sectionEl.innerHTML
            this.emptyContainer?.setAttribute('hidden', 'hidden')
            this.cartUpsells?.setAttribute('hidden', 'hidden')
            this.input.setAttribute('aria-expanded', 'true')

            const resultsContainer = this.querySelector('#predictive-search-results')
            if (this.status && resultsContainer) {
              this.status.textContent = resultsContainer.dataset.resultsText || ''
            }

            this.results.querySelectorAll('.jdgm-prev-badge__stars').forEach(elem => {
              elem.setAttribute('tabindex', '-1')
            })
            this.handleAccessibility()
          }
        }
      } catch (err) {
        if (err.name !== 'AbortError') {
          if (typeof window.zenaLog === 'function') {
            window.zenaLog('warn', 'Predictive search query error', err)
          }
        }
      }
    } else {
      this.emptyContainer?.removeAttribute('hidden')
      this.cartUpsells?.removeAttribute('hidden')
      this.results.innerHTML = ''
      this.input.setAttribute('aria-expanded', 'false')
      this.input.removeAttribute('aria-activedescendant')
      if (this.status) this.status.textContent = ''
    }
  }

  handleAccessibility () {
    let x = -1

    const listenKeyup = (event) => {
      const items = this.querySelectorAll('#predictive-search-results a, #predictive-search-results button')
      if (!items.length) return

      if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
        items.forEach(elem => {
          elem.closest('[role="option"]')?.setAttribute('aria-selected', 'false')
        })
      }

      switch (event.code) {
        case 'ArrowUp':
          if (x <= 0) {
            x = items.length
          }
          x--
          items.forEach((elem, index) => {
            if (index === x) {
              elem.focus()
              const opt = elem.closest('[role="option"]')
              opt?.setAttribute('aria-selected', 'true')
              if (opt?.id) this.input.setAttribute('aria-activedescendant', opt.id)
            }
          })
          break
        case 'ArrowDown':
          if (x === items.length - 1) {
            x = -1
          }
          x++
          items.forEach((elem, index) => {
            if (index === x) {
              elem.focus()
              const opt = elem.closest('[role="option"]')
              opt?.setAttribute('aria-selected', 'true')
              if (opt?.id) this.input.setAttribute('aria-activedescendant', opt.id)
            }
          })
          break
        case 'Enter':
          break
      }
    }

    if (!this.accessibilityEventIsInit) {
      this.addEventListener('keyup', listenKeyup)
      this.accessibilityEventIsInit = true
    }
  }
}

customElements.define('predictive-search', PredictiveSearch)
